module.exports = fox._r("images/pirates/gift-123.png", __webpack_public_path__ + "_/_/_/_/common/liveshow/images/pirates/gift-123.png");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/common/liveshow/images/pirates/gift-123.png
// module id = 324
// module chunks = 4